import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_ENDPOINTS } from '../../../core/providers/constants/api.constants';
import { AssemblyItem } from '../types/assembly-item';
import {
  AddAssemblyItemBody,
  AssemblyItemApiDto,
  UpdateAssemblyItemBody,
} from '../dto/assembly-item.dto';
import { CompressionBom } from '../types/compression';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteAssemblyItemService extends IApiBackendRouteService {
  constructor(protected readonly http: HttpClient) {
    super();
  }

  urlRoute = `${API_ENDPOINTS.ASSEMBLY_ITEMS}`;

  searchItems(name?: string): Observable<AssemblyItem[]> {
    return this.http.get<AssemblyItem[]>(
      `${this.urlRoute}/search?itemName=${name}`
    );
  }

  getItem(id: number): Observable<AssemblyItem> {
    return this.http.get<AssemblyItem>(`${this.urlRoute}/${id}`);
  }

  getInfo(id: number): Observable<AssemblyItem> {
    return this.http.get<AssemblyItem>(`${this.urlRoute}/${id}/info`);
  }

  getFormData(itemId: number): Observable<AssemblyItemApiDto['getFormData']> {
    return this.http.get<AssemblyItemApiDto['getFormData']>(
      `${this.urlRoute}/${itemId}/form-select`
    );
  }

  getCompressionBom(id: number): Observable<CompressionBom[]> {
    return this.http.get<CompressionBom[]>(
      `${this.urlRoute}/${id}/compression-bom`
    );
  }

  addItem(body: AddAssemblyItemBody): Observable<AssemblyItem> {
    return this.http.post<AssemblyItem>(`${this.urlRoute}`, body);
  }

  importBOMScanner(body: AddAssemblyItemBody[]): Observable<AssemblyItem[]> {
    return this.http.post<AssemblyItem[]>(`${this.urlRoute}/bom`, body);
  }

  updateItem(
    id: number,
    body: UpdateAssemblyItemBody
  ): Observable<AssemblyItem> {
    return this.http.patch<AssemblyItem>(`${this.urlRoute}/${id}`, body);
  }

  getAssemblyDepartment(id: number): Observable<AssemblyItem[]> {
    return this.http.get<AssemblyItem[]>(this.urlRoute + '/department/' + id);
  }

  getDestinations(): Observable<{id: number, title: string}[]> {
    return this.http.get<{id: number, title: string}[]>(`${this.urlRoute}/destinations`);
  }

  getEfficiencyStandardsByDepartment(departmentId: number): Observable<Record<string, number>> {
    return this.http.get<Record<string, number>>(
      `${this.urlRoute}/department/${departmentId}/efficiency-standards`
    );
  }
}
